var _effectorFileName = "/builds/gmini/front-ui-kit/src/Groupings/Groupings.tsx";
import { Popover } from '@mui/material';
import React from 'react';
import { PlusCircle, DeleteFilled } from '../icons';
import { Button } from '../Button';
import { ReferenceLine, GroupingFooterLayout, GropingContainer, GroupingHeader, HeaderText, HeaderTextWrap, PopoverContent, ButtonsWrap, ModalDeleteButton, ModalDeleteText, ModalDeleteButtonText, PropertyList, SelectWrapper, GroupingsWrapper } from './Groupings.styled';
import { GroupingRowLayout } from './GroupingRowLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Groupings({
  pending,
  propertyList,
  onDeleteGrouping,
  onChangeProperty,
  disabled,
  onListOpen,
  onRemoveRow,
  rowsCount,
  addRow,
  getValue,
  rowsLimit = 5,
  groupingExists,
  notSelectedValue,
  emptyRows,
  readOnly,
  adaptiveMode
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickDelete = event => {
    setAnchorEl(event.currentTarget);
  };

  const rows = React.useMemo(() => [...Array(rowsCount).keys()], [rowsCount]);

  const handleCloseConfirmDelete = () => {
    setAnchorEl(null);
  };

  const handleConfirmDelete = () => {
    onDeleteGrouping();
    handleCloseConfirmDelete();
  };

  const open = Boolean(anchorEl);
  return /*#__PURE__*/_jsx(GroupingsWrapper, {
    children: readOnly && !groupingExists ? /*#__PURE__*/_jsx(GroupingHeader, {
      children: /*#__PURE__*/_jsx(HeaderTextWrap, {
        children: /*#__PURE__*/_jsx(HeaderText, {
          children: "\u0413\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430 \u043D\u0435 \u0437\u0430\u0434\u0430\u043D\u0430"
        })
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(GroupingHeader, {
        children: [/*#__PURE__*/_jsx(HeaderTextWrap, {
          children: /*#__PURE__*/_jsx(HeaderText, {
            children: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438"
          })
        }), !readOnly && /*#__PURE__*/_jsx(Button, {
          color: "secondary",
          disabled: disabled || pending || !groupingExists,
          onClick: handleClickDelete,
          leftIcon: /*#__PURE__*/_jsx(DeleteFilled, {}),
          children: !adaptiveMode && 'Удалить группировку'
        })]
      }), /*#__PURE__*/_jsxs(GropingContainer, {
        children: [rows.map(order => /*#__PURE__*/_jsx(PropertyList, {
          children: /*#__PURE__*/_jsxs(SelectWrapper, {
            paddingLeft: order * 24 + 2,
            children: [Boolean(order) && /*#__PURE__*/_jsx(ReferenceLine, {
              height: 32
            }), /*#__PURE__*/_jsx(GroupingRowLayout, {
              onChange: (value, order) => {
                if (value) {
                  onChangeProperty(value, order);
                }
              },
              order: order,
              getValue: getValue,
              pending: pending,
              propertyList: propertyList,
              onListOpen: onListOpen,
              onDelete: (e, order) => {
                onRemoveRow(order);
              },
              disabled: disabled,
              emptyRows: emptyRows,
              readOnly: readOnly
            })]
          })
        }, order)), /*#__PURE__*/_jsx(GroupingFooterLayout, {
          lastRow: rows.length === rowsLimit,
          paddingLeft: rows.length * 24 + 2,
          children: !readOnly && rows.length < rowsLimit && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ReferenceLine, {
              height: 17
            }), /*#__PURE__*/_jsx(Button, {
              color: "tertiary",
              disabled: pending || notSelectedValue || disabled,
              onClick: addRow,
              leftIcon: /*#__PURE__*/_jsx(PlusCircle, {
                width: "15px",
                height: "15px"
              }),
              children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u0435"
            })]
          })
        }), /*#__PURE__*/_jsx(Popover, {
          open: open,
          anchorEl: anchorEl,
          onClose: handleCloseConfirmDelete,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          children: /*#__PURE__*/_jsxs(PopoverContent, {
            children: [/*#__PURE__*/_jsxs(ModalDeleteText, {
              children: ["\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C ", /*#__PURE__*/_jsx("br", {}), " \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0443?"]
            }), /*#__PURE__*/_jsxs(ButtonsWrap, {
              children: [/*#__PURE__*/_jsx(ModalDeleteButton, {
                onClick: handleConfirmDelete,
                children: /*#__PURE__*/_jsx(ModalDeleteButtonText, {
                  children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: handleCloseConfirmDelete,
                children: /*#__PURE__*/_jsx(ModalDeleteButtonText, {
                  children: "\u041E\u0442\u043C\u0435\u043D\u0430"
                })
              })]
            })]
          })
        })]
      })]
    })
  });
}